import * as css from 'css/exports.module.scss';
import './SearchItem.scss';
import { ActiveIndicator } from '@ui/icons';
import { VersionNumber } from '@ui/VersionNumber';
import { EmailTemplateStatus, RuleStatus } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { shouldItemShowApiName, shouldItemShowParent } from './arch/lib';
import { Space, Tooltip } from 'antd';
const delimiter = '.';
function getItemDisplayName(item, type) {
    const { displayName, parentDisplayName, internalName } = item;
    if (shouldItemShowApiName(type)) {
        return (React.createElement(Tooltip, { mouseEnterDelay: 0.5, open: displayName.length + internalName.length > 33 ? undefined : false, placement: 'right', title: internalName },
            React.createElement(Space, { size: Number(css.size8) },
                React.createElement("span", { className: 'display' }, displayName),
                React.createElement("span", { className: 'secondary-text' }, internalName))));
    }
    if (shouldItemShowParent(type)) {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'secondary-text' }, parentDisplayName),
            React.createElement("span", { className: 'dot' }, delimiter),
            React.createElement("span", { className: 'display' }, displayName)));
    }
    return React.createElement("span", { className: 'display' }, displayName);
}
function getActiveIndicator(status) {
    if (status === undefined) {
        return undefined;
    }
    return status === RuleStatus.Active || status === EmailTemplateStatus.Published;
}
export const SearchItem = ({ item, onClick, type }) => {
    const status = item === null || item === void 0 ? void 0 : item.status;
    const handleClick = useCallback(() => {
        if (onClick) {
            onClick(item, type);
        }
    }, [item, onClick, type]);
    return (React.createElement("div", { className: 'search-item', onClick: handleClick },
        React.createElement("span", { className: 'name' },
            getItemDisplayName(item, type),
            React.createElement(VersionNumber, { number: item.versionNumber })),
        React.createElement(ActiveIndicator, { isActive: getActiveIndicator(status) })));
};
